import "../Catalogs.scss";
import { isEmpty } from "lodash";
import { useDispatch } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import CreateBusBasics from "./CreateBusBasics";
import CreateBusDetails from "./CreateBusDetails";
import { setCloneTemplate } from "../../../store/CatalogSlice";
import ConfirmationDialog from "../../CommonComponents/confirmation_dialog/ConfirmationDialog";
import { BusFormDataType } from "../Catalogs";
import { BASIC_BUS_DATA_FIELDS } from "../utils/constants";


interface CreateBusProps {
    mode: "Create" | "Update" | "Clone" | null;
    busData: BusFormDataType;
    setBusData: React.Dispatch<React.SetStateAction<BusFormDataType>>;
    allCatalog: any[];
    componentType: string;
    editedTemplateData: any;
    blankTemplateData: { [key: string]: any; };
    setOpenConfigurationModal: React.Dispatch<React.SetStateAction<"Create" | "Update" | "Clone" | null>>;
    setRefreshCatalog: () => void
    modalLoader: boolean
    setModalLoader: React.Dispatch<React.SetStateAction<boolean>>
}

const CreateBus = ({ mode, editedTemplateData, busData, setBusData, allCatalog, componentType, setOpenConfigurationModal, setRefreshCatalog, blankTemplateData, modalLoader, setModalLoader }: CreateBusProps) => {

    const dispatch = useDispatch();
    const [createBusStage, setCreateBusStage] = useState<'first' | 'second'>('first');

    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

    useEffect(() => {
        if (isEmpty(blankTemplateData) || mode === 'Update') return;
        const inertia = blankTemplateData?.['assembly']?.[0]?.['iADCS']?.['atmos-data']?.['inertia']
        setBusData(prev => ({
            ...prev,
            inertia: inertia || prev?.inertia
        }))
    }, [blankTemplateData, mode])

    return (
        <Fragment>
            {createBusStage === 'first' &&
                <CreateBusDetails
                    allCatalog={allCatalog}
                    setOpenConfirmationDialog={setOpenConfirmationDialog}
                    setCreateBusStage={setCreateBusStage}
                    blankTemplateData={blankTemplateData}
                />
            }
            {createBusStage === 'second' &&
                <CreateBusBasics
                    mode={mode}
                    busData={busData}
                    setBusData={setBusData}
                    componentType={componentType}
                    editedTemplateData={editedTemplateData}
                    setOpenConfigurationModal={setOpenConfigurationModal}
                    setCreateBusStage={setCreateBusStage}
                    blankTemplateData={blankTemplateData}
                    setRefreshCatalog={setRefreshCatalog}
                    setOpenConfirmationDialog={setOpenConfirmationDialog}
                    modalLoader={modalLoader}
                    setModalLoader={setModalLoader}
                />
            }

            <ConfirmationDialog
                type='cancel'
                title={`Exit Bus ${mode}`}
                open={openConfirmationDialog}
                description={`All settings will be lost. Are you sure you want to exit?`}
                onCancel={() => {
                    setOpenConfirmationDialog(false)
                }}
                onConfirm={() => {
                    dispatch(setCloneTemplate({}))
                    setBusData(BASIC_BUS_DATA_FIELDS)
                    setOpenConfigurationModal(null);
                }}
                confirm_button_text={`Exit`}
            />
        </Fragment>
    )
};

export default CreateBus;